<template>
  <div class="t-btn _green _big" @click="openCookieSettingModal()">{{ $root.staticText.cookies.editCookie }}</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { consentService } from '@shared/services/consent'
import { MODAL_TYPE_RESULT } from '@shared/const/modal.const'

export default {
  name: 'CookeModalBtn',
  computed: {
    ...mapGetters({ modalResult: 'modal/modalResult' }),
  },
  methods: {
    ...mapActions('modal', ['modalType_consentOpen']),

    async openCookieSettingModal() {
      await this.modalType_consentOpen(consentService.getConsent())
    },

    refreshPage() {
      window.location.reload()
    },
  },
  watch: {
    async modalResult(result) {
      if (result?.type === MODAL_TYPE_RESULT.consentChanged) {
        consentService.setConsent(result.data)
        await consentService.sendLog()
        this.refreshPage()
      }
    },
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/ui-components/banner/components/CookeModalBtn.vue